import { theme } from '@theme';
import { ChangeEvent, FC, useMemo } from 'react';
import styled from 'styled-components';

type NoteInputProps = {
  noteInput: string;
  placeholderText: string;
  handleSaveClick: () => Promise<void>;
  handleNoteChanged: (e: ChangeEvent<HTMLTextAreaElement>) => void;
};

const NoteInput: FC<NoteInputProps> = ({
  noteInput,
  placeholderText,
  handleSaveClick,
  handleNoteChanged,
}) => {
  const isFormValid = useMemo(() => {
    return noteInput.length > 0 && noteInput !== placeholderText;
  }, [noteInput, placeholderText]);
  return (
    <ModalInputContainer data-testid='note-modal-input-container'>
      <NoteTextArea
        data-testid='note-modal-input'
        id='note-modal-input'
        isFormValid={isFormValid}
        placeholder={placeholderText}
        value={noteInput}
        onChange={(e) => handleNoteChanged(e)}
      ></NoteTextArea>
      <SendButton
        data-testid='note-submit-button'
        onClick={handleSaveClick}
        disabled={!isFormValid}
      >
        SAVE
      </SendButton>
    </ModalInputContainer>
  );
};

type NoteTextAreaProps = {
  isFormValid: boolean;
};

const NoteTextArea = styled.textarea<NoteTextAreaProps>`
  width: 90%;
  padding: 6px 12px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid ${theme.palette.lightGrey};
  color: ${(props) => (props.isFormValid ? theme.palette.black : theme.palette.dusty)};
  height: auto;
  overflow: auto;
  resize: vertical;
  :focus {
    box-shadow:
      inset 0 1px 1px rgb(0 0 0 / 8%),
      0 0 8px rgb(85 52 140 / 60%);
    border-color: #9972c9;
    outline: 0;
  }
`;

const SendButton = styled.button`
  padding: 6px 12px;
  border: 1px solid ${theme.palette.darkPurple};
  border-radius: 4px;
  color: ${theme.palette.white};
  font-wight: ${theme.typography.fontWeights.bold};
  vertical-align: top;
  order-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  float: right;
  width: 61px;
  heigh: 31px;
  background-color: ${(props) =>
    props.disabled ? theme.palette.vehiclePreferencesGrayOutButtonColor : theme.palette.darkPurple};
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    color: ${theme.palette.lightGrayTwo};
    border: 1px solid ${theme.palette.backgroundGray};
  }
`;

const ModalInputContainer = styled.div`
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 21px 20px;
  gap: 10px;
`;

export default NoteInput;
